
import React from 'react';

function EventsPage() {
  return (
    <div>
      <h1>Events page test</h1>
    </div>
  );
}

export default EventsPage;